// Children of ViewAuthenticated for all data sources admin
export const sourcesRoutes = [
    {
        path: 'sources',
        components: {
            default: () => import('@/features/sources/views/SourcesRouterView.vue'),
        },
        children: [
            {
                path: '',
                name: 'sources',
                redirect: { name: 'sources-payors-index' },
            },
            {
                path: 'mrf-generations',
                components: {
                    default: () =>
                        import('@/features/sources/views/mrf-generations/SourcesMrfGenerationsRouterView.vue'),
                },
                children: [
                    {
                        path: '',
                        name: 'sources-mrf-generations-index',
                        components: {
                            default: () =>
                                import('@/features/sources/views/mrf-generations/SourcesMrfGenerationsIndexView.vue'),
                            heading: () =>
                                import('@/features/sources/views/mrf-generations/SourcesMrfGenerationsIndexHeadingView.vue'),
                        },
                        meta: { title: 'MRF Generations' },
                    },
                ],
            },
            {
                path: 'data-ops',
                components: {
                    default: () => import('@/features/sources/views/data-ops/SourcesDataOpsRouterView.vue'),
                },
                children: [
                    {
                        path: '',
                        name: 'sources-data-ops-index',
                        components: {
                            default: () => import('@/features/sources/views/data-ops/SourcesDataOpsIndexView.vue'),
                            heading: () =>
                                import('@/features/sources/views/data-ops/SourcesDataOpsIndexHeadingView.vue'),
                        },
                        meta: { title: 'Data Ops Control Room' },
                    },
                    {
                        path: 'networks-locations',
                        name: 'sources-data-ops-networks-locations',
                        components: {
                            default: () =>
                                import('@/features/sources/views/data-ops/SourcesDataOpsNetworksLocationsView.vue'),
                            heading: () =>
                                import('@/features/sources/views/data-ops/SourcesDataOpsNetworksLocationsHeadingView.vue'),
                        },
                        meta: { title: 'Data Ops - Networks & Locations' },
                    },
                    {
                        path: 'indexes',
                        name: 'sources-data-ops-indexes',
                        components: {
                            default: () => import('@/features/sources/views/data-ops/SourcesDataOpsIndexesView.vue'),
                            heading: () =>
                                import('@/features/sources/views/data-ops/SourcesDataOpsIndexIngestionsHeadingView.vue'),
                        },
                        meta: { title: 'Data Ops - Indexes' },
                    },
                ],
            },
            {
                path: 'audits',
                components: {
                    default: () => import('@/features/sources/views/audits/SourcesAuditsRouterView.vue'),
                },
                children: [
                    {
                        path: '',
                        name: 'sources-audits-index',
                        redirect: { name: 'sources-audits-networks-index' },
                    },
                    {
                        path: 'networks',
                        component: () =>
                            import('@/features/sources/views/audits/networks/SourcesAuditsNetworksRouterView.vue'),
                        children: [
                            {
                                path: '',
                                name: 'sources-audits-networks-index',
                                components: {
                                    default: () =>
                                        import('@/features/sources/views/audits/networks/SourcesAuditsNetworksIndexView.vue'),
                                    heading: () =>
                                        import('@/features/sources/views/audits/networks/SourcesAuditsNetworksIndexHeadingView.vue'),
                                    actions: () =>
                                        import('@/features/sources/views/audits/networks/SourcesAuditsNetworksIndexActionsView.vue'),
                                },
                            },
                            {
                                path: 'network/:networkId',
                                name: 'sources-audits-network-record',
                                components: {
                                    default: () =>
                                        import('@/features/sources/views/audits/networks/SourcesAuditsNetworksShowView.vue'),
                                    heading: () =>
                                        import('@/features/sources/views/audits/networks/SourcesAuditsNetworksShowHeadingView.vue'),
                                },
                            },
                        ],
                    },
                    {
                        path: 'locations',
                        component: () =>
                            import('@/features/sources/views/audits/locations/SourcesAuditsLocationsRouterView.vue'),
                        children: [
                            {
                                path: '',
                                name: 'sources-audits-locations-index',
                                beforeEnter: (to, from, next) => {
                                    // Redirect to default mode if none is set
                                    if (!to.query.mode) {
                                        next({
                                            ...to,
                                            query: { mode: 'npi_review', npis: 'is_null' },
                                            replace: true,
                                        })
                                    } else {
                                        next()
                                    }
                                },
                                components: {
                                    default: () =>
                                        import('@/features/sources/views/audits/locations/SourcesAuditsLocationsIndexView.vue'),
                                    heading: () =>
                                        import('@/features/sources/views/audits/locations/SourcesAuditsLocationsIndexHeadingView.vue'),
                                },
                            },
                            {
                                path: 'location/:locationId',
                                name: 'sources-audits-locations-show',
                                components: {
                                    default: () =>
                                        import('@/features/sources/views/audits/locations/SourcesAuditsLocationsShowView.vue'),
                                    heading: () =>
                                        import('@/features/sources/views/audits/locations/SourcesAuditsLocationsShowHeadingView.vue'),
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'index-templates/:indexTemplateId',
                components: {
                    default: () => import('@/components/index-template/IndexTemplate.vue'),
                },
            },
            {
                path: 'payors',
                component: () => import('@/features/sources/views/payors/SourcesPayorsRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sources-payors-index',
                        components: {
                            default: () => import('@/features/sources/views/payors/SourcesPayorsIndexView.vue'),
                            heading: () => import('@/features/sources/views/payors/SourcesPayorsIndexHeadingView.vue'),
                        },
                        meta: { title: 'Payors' },
                    },
                    {
                        path: ':payorId',
                        components: {
                            default: () => import('@/features/sources/views/payors/SourcesPayorsRecordView.vue'),
                            heading: () => import('@/features/sources/views/payors/SourcesPayorsRecordHeadingView.vue'),
                        },
                        meta: { title: 'Payor Details' },
                        children: [
                            {
                                path: '',
                                name: 'sources-payors-record',
                                redirect: { name: 'sources-payors-record-comments' },
                            },
                            {
                                path: 'comments',
                                name: 'sources-payors-record-comments',
                                component: () =>
                                    import('@/features/sources/views/payors/SourcesPayorsRecordCommentsView.vue'),
                            },
                            {
                                path: 'index/:indexId/run/:runId',
                                component: () =>
                                    import('@/features/sources/views/payors/SourcesPayorsRecordResultsView.vue'),
                                children: [
                                    {
                                        path: '',
                                        name: 'sources-payors-record-results',
                                        redirect: { name: 'sources-payors-record-files' },
                                    },
                                    {
                                        path: 'files',
                                        name: 'sources-payors-record-files',
                                        components: {
                                            default: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsFilesView.vue'),
                                            count: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsFilesCountView.vue'),
                                            search: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsFilesSearchView.vue'),
                                            searchFilters: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsFilesSearchFiltersView.vue'),
                                        },
                                    },
                                    {
                                        path: 'reporting-plans',
                                        name: 'sources-payors-record-reporting-plans',
                                        components: {
                                            default: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsReportingPlansView.vue'),
                                            count: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsReportingPlansCountView.vue'),
                                            search: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsReportingPlansSearchView.vue'),
                                            searchFilters: () =>
                                                import('@/features/sources/views/payors/SourcesPayorsRecordResultsReportingPlansSearchFiltersView.vue'),
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'tpas',
                component: () => import('@/features/sources/views/tpas/SourcesTPAsRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sources-tpas-index',
                        components: {
                            default: () => import('@/features/sources/views/tpas/SourcesTPAsIndexView.vue'),
                            heading: () => import('@/features/sources/views/tpas/SourcesTPAsIndexHeadingView.vue'),
                        },
                        meta: { title: 'TPAs' },
                    },
                    {
                        path: ':thirdPartyAdministratorId',
                        components: {
                            default: () => import('@/features/sources/views/tpas/SourcesTPAsRecordView.vue'),
                            heading: () => import('@/features/sources/views/tpas/SourcesTPAsRecordHeadingView.vue'),
                        },
                        meta: { title: 'TPA Details' },
                        children: [
                            {
                                path: '',
                                name: 'sources-tpas-record',
                                redirect: { name: 'sources-tpas-record-comments' },
                            },
                            {
                                path: 'comments',
                                name: 'sources-tpas-record-comments',
                                component: () =>
                                    import('@/features/sources/views/tpas/SourcesTPAsRecordCommentsView.vue'),
                            },
                            {
                                path: 'index/:indexId/run/:runId',
                                component: () =>
                                    import('@/features/sources/views/tpas/SourcesTPAsRecordResultsView.vue'),
                                children: [
                                    {
                                        path: '',
                                        name: 'sources-tpas-record-results',
                                        redirect: { name: 'sources-tpas-record-files' },
                                    },
                                    {
                                        path: 'files',
                                        name: 'sources-tpas-record-files',
                                        components: {
                                            default: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsFilesView.vue'),
                                            count: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsFilesCountView.vue'),
                                            search: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsFilesSearchView.vue'),
                                            searchFilters: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsFilesSearchFiltersView.vue'),
                                        },
                                    },
                                    {
                                        path: 'reporting-plans',
                                        name: 'sources-tpas-record-reporting-plans',
                                        components: {
                                            default: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsReportingPlansView.vue'),
                                            count: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsReportingPlansCountView.vue'),
                                            search: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsReportingPlansSearchView.vue'),
                                            searchFilters: () =>
                                                import('@/features/sources/views/tpas/SourcesTPAsRecordResultsReportingPlansSearchFiltersView.vue'),
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'health-systems',
                component: () => import('@/features/sources/views/health-systems/SourcesHealthSystemsRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sources-health-systems-index',
                        components: {
                            default: () =>
                                import('@/features/sources/views/health-systems/SourcesHealthSystemsIndexView.vue'),
                            heading: () =>
                                import('@/features/sources/views/health-systems/SourcesHealthSystemsIndexHeadingView.vue'),
                        },
                        meta: { title: 'Health Systems' },
                    },
                    {
                        path: ':healthSystemId',
                        components: {
                            default: () =>
                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordView.vue'),
                            heading: () =>
                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordHeadingView.vue'),
                        },
                        meta: { title: 'Health System Details' },
                        children: [
                            {
                                path: '',
                                name: 'sources-health-systems-record',
                                redirect: { name: 'sources-health-systems-record-comments' },
                            },
                            {
                                path: 'comments',
                                name: 'sources-health-systems-record-comments',
                                component: () =>
                                    import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordCommentsView.vue'),
                            },
                            {
                                path: 'index/:indexId/run/:runId',
                                component: () =>
                                    import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsView.vue'),
                                children: [
                                    {
                                        path: '',
                                        name: 'sources-health-systems-record-results',
                                        redirect: { name: 'sources-health-systems-record-files' },
                                    },
                                    {
                                        path: 'files',
                                        name: 'sources-health-systems-record-files',
                                        components: {
                                            default: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsFilesView.vue'),
                                            count: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsFilesCountView.vue'),
                                            search: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsFilesSearchView.vue'),
                                            searchFilters: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsFilesSearchFiltersView.vue'),
                                        },
                                    },
                                    {
                                        path: 'locations',
                                        name: 'sources-health-systems-record-locations',
                                        components: {
                                            default: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsLocationsView.vue'),
                                            count: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsLocationsCountView.vue'),
                                            search: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsLocationsSearchView.vue'),
                                            searchFilters: () =>
                                                import('@/features/sources/views/health-systems/SourcesHealthSystemsRecordResultsLocationsSearchFiltersView.vue'),
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'locations',
                component: () => import('@/features/sources/views/location/SourcesLocationRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sources-location-list',
                        components: {
                            default: () => import('@/features/sources/views/location/SourcesLocationListView.vue'),
                        },
                    },
                    {
                        path: 'location/:locationId',
                        name: 'sources-location-show',
                        components: {
                            default: () =>
                                import('@/features/sources/views/audits/locations/SourcesAuditsLocationsShowView.vue'),
                            heading: () =>
                                import('@/features/sources/views/audits/locations/SourcesAuditsLocationsShowHeadingView.vue'),
                        },
                    },
                ],
            },
            {
                path: 'location-templates',
                component: () =>
                    import('@/features/sources/views/location-template/SourcesLocationTemplateRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'sources-location-template-list',
                        components: {
                            default: () =>
                                import('@/features/sources/views/location-template/SourcesLocationTemplateListView.vue'),
                            heading: () =>
                                import('@/features/sources/views/location-template/SourcesLocationTemplateListHeadingView.vue'),
                        },
                    },
                ],
            },
        ],
    },
]
